import { render, staticRenderFns } from "./ybPagination.vue?vue&type=template&id=2da83bc4&scoped=true"
import script from "./ybPagination.vue?vue&type=script&lang=js"
export * from "./ybPagination.vue?vue&type=script&lang=js"
import style0 from "./ybPagination.vue?vue&type=style&index=0&id=2da83bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da83bc4",
  null
  
)

export default component.exports